import { render, staticRenderFns } from "./select-tertiary.vue?vue&type=template&id=7ffc4e24&scoped=true&"
import script from "./select-tertiary.vue?vue&type=script&lang=js&"
export * from "./select-tertiary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc4e24",
  null
  
)

export default component.exports